export const participantIdsInUse = (group) => {
  const ids = new Set();
  for (const expense of group?.expenses || []) {
    if (expense.payer !== undefined && expense.payer !== null) {
      ids.add(String(expense.payer));
    }
    for (const receiver of expense.receivers || []) {
      if (receiver.participant_id !== undefined && receiver.participant_id !== null) {
        ids.add(String(receiver.participant_id));
      }
    }
  }
  return ids;
};
